export const sellerTypeList = [
    { value: 0, label: 'Firma' },
    { value: 1, label: 'Zwykły' },
];

export const companyTypeList = [
    { value: 0, label: 'Zasady ogólne - 12%' },
    { value: 1, label: 'Zasady ogólne - 32%' },
    { value: 2, label: 'Podatek liniowy 19%' },
    { value: 3, label: 'Ryczałt - 2%' },
    { value: 4, label: 'Ryczałt - 3%' },
    { value: 5, label: 'Ryczałt - 5,5%' },
    { value: 6, label: 'Ryczałt - 8,5%' },
    { value: 7, label: 'Ryczałt - 10%' },
    { value: 8, label: 'Ryczałt - 12%' },
    { value: 9, label: 'Ryczałt - 12,5%' },
    { value: 10, label: 'Ryczałt - 14%' },
    { value: 11, label: 'Ryczałt - 15%' },
    { value: 12, label: 'Ryczałt - 17%' },
    { value: 13, label: 'Spółka / Podatnik CIT - 9%' },
    { value: 14, label: 'Spółka / Podatnik CIT - 19%' },
];

export const vatValueList = [
    { value: 0, vatValue: 0.23, label: '23.00%' },
    { value: 1, vatValue: 0.08, label: '8.00%' },
    { value: 2, vatValue: 0.05, label: '5.00%' },
    { value: 3, vatValue: 0.00, label: '0.00%' },
];

export const specialZoneMartList = [
    { value: 0, label: 'Brak' },
    { value: 1, label: 'HIT' },
    { value: 2, label: 'Okazja' },
    { value: 3, label: 'Rabat ilościowy' },
    { value: 4, label: 'Nowość' },
];

export const highlightList = [
    { value: 0, label: 'Brak' },
    { value: 1, label: 'Wyróżnienie' },
    { value: 2, label: 'Wyróżnienie elastyczne' },
    { value: 3, label: 'Pakiet promo' },
];


